// formats the markdown for the Open AI response used in Martin AI Assistant
export const formatAiResponseMarkdown = (markdown: string): string => {
  // Remove the first main heading
  let strippedMarkdown = markdown.replace(/^#\s.*\n*\n*/, '');
  // Replace all "### step" headers with a bullet point
  strippedMarkdown = strippedMarkdown.replace(/###\s*step\s*\n*/g, '• ');
  // Remove numbered lists at the start of lines
  strippedMarkdown = strippedMarkdown.replace(/^\d+\.\s*/gm, '');
  // Remove any "# suggestion" section and its content until the end
  strippedMarkdown = strippedMarkdown.replace(/\n*#\s*suggestion[\s\S]*$/, '');
  // Format code blocks properly by ensuring they have language identifier
  strippedMarkdown = strippedMarkdown.replace(
    /###\s*code\s*\n+([\s\S]*?)(?=\n{2}|$)/g,
    (_, codeContent) => {
      // Detect if there's a language specified in the first line
      const lines = codeContent.trim().split('\n');
      const firstLine = lines[0].trim();
      const languageMatch = firstLine.match(/^(\w+):?$/);

      if (languageMatch) {
        // If language is specified, use it and remove the language line
        return `\`\`\`${languageMatch[1]}\n${lines
          .slice(1)
          .join('\n')}\n\`\`\`\n`;
      } else {
        // If no language specified, use plain text
        return `\`\`\`\n${codeContent.trim()}\n\`\`\`\n`;
      }
    },
  );
  return strippedMarkdown.trim();
};
